{
  "admin": {
    "fast-forward": "Быстрая перемотка",
    "no-segment-pause": "Не останавливаться на сегментах",
    "show-correct-answers": "Показать правильные ответы",
    "title": "Тестовый режим",
    "transfer-to-new-device": "Перенести на новое устройство",
    "video-stats": "Показать статистику видео"
  },
  "android-app": {
    "download-button": "Скачать в Google Play",
    "footer-note": "Не можете найти, где ввести код? После открытия приложения вы увидите экран «Вход для сотрудников».",
    "heading": "Установите приложение и войдите с вашим кодом",
    "how-to-start": "Как начать:",
    "intro": "Что вы получаете:",
    "notifications-desc": "Получайте уведомления в реальном времени без необходимости вручную проверять приложение.",
    "notifications-title": "Push-уведомления в реальном времени",
    "scanner-desc": "Умная камера автоматически распознаёт границы документа, корректирует перспективу и оптимизирует освещение для лучшей читаемости текста.",
    "scanner-title": "Продвинутый сканер документов",
    "step1": "Скачайте приложение:",
    "step2": "Откройте его",
    "step3": "Введите следующий код:",
    "title": "Приложение для Android"
  },
  "broadcast": {
    "from": "Отправлено от <Name/> на <SentAt/>",
    "mark-as-read": "Читать",
    "mark-as-read-confirm": {
      "title": "Подпишите, чтобы подтвердить, что вы прочитали и поняли это сообщение"
    },
    "read-at": "Прочитано <Name/> в <ReadAt/>"
  },
  "control-card": {
    "action": {
      "complete": "Завершить карточку",
      "print": "Печать",
      "signature": "Подпись",
      "title": "Действия с карточкой контроля",
      "uncomplete": "Разблокировать карточку",
      "view-print": "Просмотр / Печать"
    },
    "add-new-record-title": "Добавить новую запись в {{title}}",
    "breadcrumbs": {
      "row": "Запись {{current}} из {{total}}"
    },
    "comment": "Комментарий",
    "complete-alert": {
      "confirm": "Завершить",
      "message": "Чтобы завершить контрольную карту, необходимо заполнить все записи.",
      "title_one": "Есть одна запись, которая не заполнена",
      "title_few": "Есть {{count}} записей, которые не заполнены",
      "title_many": "Есть {{count}} записей, которые не заполнены",
      "title_other": "Есть {{count}} записей, которые не заполнены"
    },
    "complete-error": {
      "message_one": "Есть одна запись, которую необходимо заполнить",
      "message_few": "Есть {{count}} записей, которые необходимо заполнить",
      "message_many": "Есть {{count}} записей, которые необходимо заполнить",
      "message_other": "Есть {{count}} записей, которые необходимо заполнить",
      "title": "Контрольная карта не может быть завершена"
    },
    "due-to": "В связи с",
    "error": {
      "saving-error": "Во время сохранения данных произошла ошибка: {{message}}. Чтобы попробовать снова, нажмите кнопку \"Сохранить\""
    },
    "instantiate": {
      "confirmation-message": "Вы уверены, что хотите создать контрольную карточку \"{{name}}\"?",
      "header": "Новая карточка контроля \"{{name}}\"",
      "message": "Вы можете выбрать один из следующих вариантов:",
      "option-create-copy": "Перенести данные из этой карточки контроля",
      "option-create-empty": "Новая пустая карточка контроля"
    },
    "location": {
      "archived-title": "Архивные контрольные карты",
      "create-new": "Создать",
      "date": "Дата",
      "edit-disabled-banner": "Карточка не может быть отредактирована из-за истечения срока действия или отсутствия разрешений для завершения.",
      "label": "Местоположение",
      "no-control-cards": "Не найдено контрольных карт, удовлетворяющих условиям фильтра",
      "not-applicable": {
        "header": "Не применимо",
        "message": "Эта карта контроля отмечена как не применимая {{notApplicableBy}} по следующей причине: {{notApplicableReason}}"
      },
      "recurring": {
        "create": {
          "date": "Дата",
          "no-permission": "У вас нет разрешения на создание контрольных карточек для этой даты",
          "template": "Выберите контрольную карту",
          "title": "Новая контрольная карта"
        },
        "filter": {
          "endDate": "До",
          "label": "Фильтр",
          "startDate": "После",
          "status": "Статус",
          "statuses": {
            "all": "Завершенные и незавершенные",
            "complete": "Завершенные",
            "incomplete": "Незавершенные"
          },
          "subtitle": "Фильтровать контрольные карты по следующим критериям",
          "template": "Тип",
          "text": "Имя",
          "textPlaceholder": "Введите для поиска по имени",
          "title": "Контрольные карты для заполнения"
        },
        "load-more": "Загрузить еще от <StartDate/>"
      },
      "title": "Карточки контроля для заполнения"
    },
    "nested": {
      "create": "Создать",
      "creating": "Создание...",
      "open": "Открыть",
      "status": {
        "completed": "Завершена",
        "not-applicable": "Не применимо",
        "pending": "Незавершена"
      }
    },
    "no-locations": "У вас нет доступа к карточкам контроля в любом местоположении",
    "number-range": {
      "max-exceeded": "Число должно быть меньше, чем {{maxValue}}",
      "min-exceeded": "Число должно быть больше, чем {{minValue}}",
      "no-unit": {
        "closed": "{{start}} – {{end}}",
        "open-end": "выше {{start}}",
        "open-start": "ниже {{end}}"
      },
      "text": "Диапазон",
      "unit": {
        "closed": "{{start}} – {{end}} {{unit}}",
        "open-end": "выше {{start}} {{unit}}",
        "open-start": "ниже {{end}} {{unit}}"
      }
    },
    "override-validation-result": {
      "mark-not-applicable": "Отметить как не применимо",
      "option": {
        "not-applicable": "Не применимо",
        "other": "Другое",
        "other-placeholder": "Введите причину"
      },
      "reason-option-required": "Вы должны выбрать один из следующих вариантов:",
      "title": "Укажите причину, по которой вы не можете заполнить это поле:"
    },
    "primary-column-title_one": "В этой контрольной карте есть {{count}} запись \"{{title}}\"",
    "primary-column-title_few": "В этой контрольной карте есть {{count}} запись \"{{title}}\"",
    "primary-column-title_many": "В этой контрольной карте есть {{count}} запись \"{{title}}\"",
    "primary-column-title_other": "В этой контрольной карте есть {{count}} запись \"{{title}}\"",
    "row": {
      "action": {
        "complete": "Заблокировать и продолжить",
        "complete-error": {
          "message_one": "Есть одна запись, которую необходимо заполнить",
          "message_few": "Есть {{count}} записей, которые необходимо заполнить",
          "message_many": "Есть {{count}} записей, которые необходимо заполнить",
          "message_other": "Есть {{count}} записей, которые необходимо заполнить",
          "title": "Контрольная карта не может быть завершена"
        },
        "complete-success-last-record": "Запись успешно заблокирована и это последняя запись в контрольной карте",
        "confirm-delete": {
          "title_one": "Вы уверены, что хотите удалить эту запись?",
          "title_few": "Вы уверены, что хотите удалить эти {{count}} записи?",
          "title_many": "Вы уверены, что хотите удалить эти {{count}} записей?",
          "title_other": "Вы уверены, что хотите удалить эти {{count}} записи?",
          "title-name": "Удалить \"{{name}}\"?"
        },
        "confirm-remove-signature": {
          "title": "Вы уверены, что хотите удалить эту подпись?"
        },
        "delete": "Удалить",
        "more-info": "Дополнительная информация",
        "title": "Действия для этой записи",
        "uncomplete": "Разблокировать эту запись"
      },
      "completed-by": "Заблокировано",
      "more-info": {
        "title": "Подробности об этой записи"
      }
    },
    "status": {
      "completed": "Завершено <Name/>",
      "not-applicable": "Не применимо (отмечено {{notApplicableBy}} с причиной: {{notApplicableReason}})",
      "not-completed": "Не завершено"
    },
    "title": "Карточки контроля",
    "type": {
      "daily": "Ежедневно",
      "recurring": "Периодический"
    },
    "value": {
      "empty": "Нет значения",
      "invalid": "Недействительное значение!"
    }
  },
  "error": {
    "playback": {
      "header": "Ошибка воспроизведения темы",
      "message": "Пожалуйста, перезагрузите приложение и попробуйте снова",
      "reload-button": "Перезагрузить"
    },
    "unexpected": {
      "header": "Ошибка",
      "message": "Пожалуйста, перезагрузите приложение",
      "reload-button": "Перезагрузить"
    }
  },
  "g": {
    "action": "Действия",
    "add": "Добавить",
    "all": "Все",
    "app-name": "FSAcademy.bg",
    "attachment": {
      "delete-confirmation": {
        "title": "Вы уверены, что хотите удалить это фото?"
      }
    },
    "back": "Назад",
    "back-to-home": "Вернуться на главную",
    "cancel": "Отмена",
    "change": "Изменить",
    "clear": "Очистить",
    "close": "Закрыть",
    "combo-box": {
      "add-header": "Добавить опцию",
      "delete-title": "Вы уверены, что хотите удалить эту опцию?",
      "edit-header": "Редактировать опцию",
      "placeholder": "Введите или выберите из списка"
    },
    "complete": "Завершить",
    "continue_zero": "Продолжить",
    "continue_one": "Продолжить ({{count}})",
    "continue_few": "Продолжить ({{count}})",
    "continue_many": "Продолжить ({{count}})",
    "continue_other": "Продолжить ({{count}})",
    "copyright-and-privacy-policy": "© 2026 Ef Es Academy Ltd. ⋅ <2>Политика конфиденциальности</2>",
    "delete": "Удалить",
    "discard": "Отменить",
    "doc-file-name": "Имя файла",
    "doc-file-size": "Размер",
    "edit": "Редактировать",
    "error": {
      "disabled-error": "Ваш аккаунт деактивирован. Пожалуйста, свяжитесь с администратором",
      "network-error": "Временно нет соединения с сервером. Проверьте ваше интернет-соединение и попробуйте снова",
      "not-available-error": "Ресурс недоступен или у вас нет к нему доступа.",
      "server-error": "Ошибка сервера. Пожалуйста, попробуйте снова через некоторое время"
    },
    "feature-disabled": "Эта функция отключена для вашей компании",
    "filter": "Применить фильтр",
    "filter-button_zero": "Фильтр",
    "filter-button_one": "Фильтр ({{count}})",
    "filter-button_few": "Фильтр ({{count}})",
    "filter-button_many": "Фильтр ({{count}})",
    "filter-button_other": "Фильтр ({{count}})",
    "later": "Позже",
    "loading": "Загрузка, пожалуйста, подождите...",
    "loading-error": "Произошла непредвиденная ошибка. Пожалуйста, попробуйте снова позже.",
    "ok": "ОК",
    "page-not-found": "Страница не найдена",
    "pagination": {
      "page": "Страница {{pageNumber}} из {{pageCount}}"
    },
    "privacy-policy-url": "/legal/privacy-policy/latest-en",
    "remove": "Удалить",
    "required": "обязательно",
    "save": "Сохранить",
    "search-employee-name-or-position": "Поиск по имени или должности",
    "select-date": "Выберите дату",
    "select-employee": "Выберите сотрудника",
    "select-time": "Выберите время",
    "select-value": "Выберите",
    "share": {
      "button": "Поделиться",
      "download": {
        "downloading": "Загружается, пожалуйста, подождите...",
        "error": {
          "message": "Произошла ошибка при скачивании файла. Пожалуйста, попробуйте снова.",
          "title": "Ошибка загрузки файла"
        }
      },
      "error": {
        "generic": "Ваш браузер не поддерживает этот метод обмена файлами. Пожалуйста, попробуйте другие варианты.",
        "title": "Ошибка обмена файлами"
      },
      "pdf-file-attach": "Поделиться PDF",
      "pdf-file-download": "Скачать PDF",
      "title": "Поделиться документом {{name}}"
    },
    "upload": "Загрузить",
    "upload-more": "Загрузить еще",
    "uploaded-files_one": "Загруженные файлы: {{count}}",
    "uploaded-files_few": "Загруженные файлы: {{count}}",
    "uploaded-files_many": "Загруженные файлы: {{count}}",
    "uploaded-files_other": "Загруженные файлы: {{count}}",
    "uploading": "Загружается ({{percent}}%)",
    "user-disable": {
      "action": "Войти как другой сотрудник",
      "title": "Ваш доступ был деактивирован"
    },
    "yes": "Да"
  },
  "help": {
    "email-action": "{{email}}",
    "email-title": "Свяжитесь с нами по электронной почте:",
    "manual-action": "Открыть руководство",
    "manual-title": "Просмотрите руководство пользователя:",
    "p1": "Если у вас возникли проблемы с использованием приложения, вы можете получить помощь следующими способами:",
    "phone-action": "{{phone}}",
    "phone-title": "Свяжитесь с нами по телефону:",
    "title": "Помощь",
    "viber-action": "Чат в Viber",
    "viber-title": "Отправьте нам сообщение через Viber:",
    "work-hours": "Мы ответим в рабочие дни с 9:00 до 17:00"
  },
  "incdoc": {
    "action": {
      "confirm-delete": {
        "title": "Вы уверены, что хотите удалить этот документ?"
      },
      "delete": "Удалить",
      "edit": "Редактировать",
      "scan-result": "Просмотреть распознанный документ",
      "title": "Действия"
    },
    "add-doc": "Новый документ",
    "doc": {
      "add-document-success": "Документ успешно добавлен",
      "add-document-title": "Добавить документ",
      "ai-apply-button": "Заполнить выбранные",
      "ai-create-new": "Создать новый",
      "ai-dialog-title": "Сверьте распознанные атрибуты с документом",
      "ai-existing": "Существующий",
      "ai-fill-button": "Запустить",
      "ai-fill-label": "Заполнить с помощью ИИ",
      "ai-new": "Новый",
      "ai-no-results": "Нам не удалось распознать данные в документах. Пожалуйста, сделайте более чёткое фото — убедитесь, что достаточно света и весь документ полностью виден в кадре.",
      "ai-no-results-label": "Не удалось распознать данные с помощью ИИ",
      "ai-suggestions-button": "Просмотр",
      "ai-suggestions-label": "Мы распознали документ с помощью ИИ",
      "ai-use-existing": "Использовать существующий",
      "doc-date": "Дата документа",
      "doc-num": "Номер документа",
      "doc-num-placeholder": "Пожалуйста, введите номер документа",
      "edit-document-title": "Редактировать документ",
      "location": "Местоположение",
      "notes": "Примечания",
      "notes-placeholder": "Дополнительные примечания (при необходимости)",
      "supplier": "Поставщик",
      "update-document-success": "Документ успешно обновлен"
    },
    "doc-no": "Документ №{{docNum}}",
    "doc-subtitle": "Дата документа <2><0></0></2>, поставщик <4>{{supplierName}}</4>, местоположение <6>{{locationName}}</6>, создано <9>{{creatorName}}</9> на <11><0></0></11>",
    "filter": {
      "created-date-after": "После даты создания",
      "created-date-before": "До даты создания",
      "doc-date-after": "После даты документа",
      "doc-date-before": "До даты документа",
      "keyword": "Поиск",
      "keyword-placeholder": "Номер документа, поставщик и др.",
      "order": "Порядок",
      "order-by": {
        "created-at": "Дата создания",
        "document-date": "Дата документа"
      },
      "title": "Фильтр документов"
    },
    "no-documents": "Документы не найдены",
    "pagination-count": "{{itemCount}} документов",
    "purchase-doc": {
      "actions-title": "Действия",
      "export-excel": "Экспорт в Excel",
      "invoice-number": "Документ № {{num}}",
      "preview-title": "Предпросмотр распознавания"
    },
    "supplier": {
      "add-supplier-error": "Ошибка при добавлении поставщика",
      "add-supplier-success": "Поставщик успешно добавлен",
      "add-title": "Добавить поставщика",
      "edit-supplier-error": "Ошибка при редактировании поставщика",
      "edit-supplier-success": "Поставщик успешно отредактирован",
      "edit-title": "Редактировать поставщика",
      "eik": "ЕИК",
      "eik-placeholder": "Пожалуйста, введите ЕИК",
      "name": "Имя",
      "name-placeholder": "Пожалуйста, введите имя поставщика",
      "notes": "Примечания",
      "notes-placeholder": "Дополнительные примечания (при необходимости)"
    },
    "title": "Входящие записи",
    "upload": {
      "error": "Ошибка",
      "finished": "Завершено",
      "pending": "Ожидается",
      "uploading": "Загрузка"
    }
  },
  "login": {
    "employee-login": "Вход для сотрудников",
    "enter-your-access-code": "Пожалуйста, введите ваш код доступа",
    "failed": "Вход не выполнен. Пожалуйста, проверьте корректность кода доступа",
    "login-button": "Войти",
    "no-access-code": "У меня нет кода доступа",
    "privacy-policy": "Нажимая кнопку «Войти», вы соглашаетесь с нашей <2>политикой конфиденциальности</2>.",
    "success": "Вход выполнен успешно!",
    "welcome": "Добро пожаловать в FSAcademy!"
  },
  "menu": {
    "android-app": "Приложение для Android",
    "control-card": "Контрольная карта",
    "course": "Курс",
    "help": "Помощь",
    "incoming-control": "Входящий контроль",
    "language": "Язык",
    "logged-out": {
      "already-part-of-team": "Вы уже часть команды?",
      "contact-admin-for-code": "Свяжитесь с вашим руководителем, чтобы получить код доступа.",
      "contact-us-to": "Свяжитесь с нами, чтобы:",
      "email": "Эл. почта",
      "fully-digitize": "<0>полностью цифровизировать</0> контроль пищевой безопасности.",
      "get-demo": "получить <1>краткое демо</1> платформы.",
      "get-to-know-services": "<1>ознакомиться</1> с нашими цифровыми услугами.",
      "phone": "Телефон",
      "want-to-digitize-question": "Хотите цифровизировать вашу пищевую безопасность?"
    },
    "logout": "Выход",
    "new-badge": "Новое",
    "notifications": "Уведомления",
    "organizer": "Органайзер",
    "test-mode": "Тестовый режим",
    "tickets": "Тикеты"
  },
  "notifications": {
    "marked-all-as-read": "Все уведомления отмечены как прочитанные",
    "native": {
      "enable-notifications": "Уведомления на устройстве",
      "permission-hint": "Чтобы получать уведомления, вы должны предоставить разрешение",
      "title": "Настройки уведомлений"
    },
    "no-notifications": "Уведомлений нет",
    "read-at": "Прочитано в <ReadAtTime/>",
    "title_zero": "Уведомления",
    "title_one": "Уведомления ({{count}})",
    "title_few": "Уведомления ({{count}})",
    "title_many": "Уведомления ({{count}})",
    "title_other": "Уведомления ({{count}})",
    "unread-alert": {
      "header_one": "У вас {{count}} непрочитанное уведомление",
      "header_few": "У вас {{count}} непрочитанных уведомлений",
      "header_many": "У вас {{count}} непрочитанных уведомлений",
      "header_other": "У вас {{count}} непрочитанных уведомлений",
      "message_one": "Хотите прочитать его сейчас?",
      "message_few": "Хотите прочитать их сейчас?",
      "message_many": "Хотите прочитать их сейчас?",
      "message_other": "Хотите прочитать их сейчас?"
    }
  },
  "organizer": {
    "action": {
      "confirm-delete": {
        "title": "Вы уверены, что хотите удалить этот документ?"
      },
      "edit": "Редактировать"
    },
    "add-document-title": "Добавить документ",
    "edit-document-title": "Редактировать документ",
    "folder": {
      "add-new-document": "Новый документ",
      "add-title": "Добавить папку",
      "confirm-delete": {
        "message": "Все документы в папке будут удалены!",
        "title": "Удалить {{name}}?"
      },
      "edit": "Редактировать",
      "edit-title": "Редактировать папку",
      "name": "Имя",
      "name-placeholder": "Введите имя папки",
      "title": "Документы"
    },
    "folder-list": {
      "add": "Новая папка",
      "title": "Папки"
    },
    "form": {
      "folder": "Папка",
      "name": "Имя",
      "name-placeholder": "Введите имя документа",
      "notes": "Заметки",
      "notes-placeholder": "Дополнительные заметки (если нужно)",
      "notify-before-expiry": "Отправить мне напоминание",
      "notify-before-expiry-hint-1": "Мы отправим уведомление перед истечением срока действия документа.",
      "notify-before-expiry-hint-2": "Выберите \"Истекает\" для добавления напоминания.",
      "notify-before-expiry-placeholder": "Без напоминания",
      "notify-before-expiry-unit": "дней ранее",
      "state": "Состояние",
      "valid-from": "Дата выпуска",
      "valid-from-hint": "Не заполняйте, если нет даты выпуска",
      "valid-until": "Истекает",
      "valid-until-hint": "Не заполняйте, если нет даты истечения",
      "valid-until-quick-hint": "Быстрое истечение",
      "valid-until-quick-hint-1-month": "1 месяц",
      "valid-until-quick-hint-1-year": "1 год",
      "valid-until-quick-hint-2-years": "2 года",
      "valid-until-quick-hint-3-months": "3 месяца",
      "valid-until-quick-hint-6-months": "6 месяцев"
    },
    "location": "Местоположение",
    "never-expires": "Без срока действия",
    "no-locations": "У вас нет доступа к органайзеру в любом местоположении",
    "no-reminder-label": "Без напоминания",
    "notify-before-expiry-label": "Напоминание <ReminderDuration/> ранее",
    "state": {
      "complete": "Завершено",
      "pending": "В ожидании"
    },
    "title": "Органайзер",
    "valid-from": "Действительно с <2><0></0></2> <4></4>",
    "valid-from-until": "Действительно с <2><0></0></2> до <6><0></0></6>",
    "valid-until": "Действительно до <2><0></0></2> ",
    "validity": {
      "expired": "Истекло",
      "expires-soon": "Скоро истекает"
    }
  },
  "player": {
    "lesson-duration": "{{minutes}} минут",
    "modal": {
      "again": {
        "header": "Тема завершена",
        "sub-header": "Выберите один из следующих вариантов",
        "watch-again": "Смотреть снова"
      },
      "current": {
        "continue-button": "Продолжить",
        "continue-header": "Нажмите, чтобы продолжить",
        "ended-header": "Тема завершена",
        "go-to-test": "Перейти к тесту"
      },
      "segment": {
        "back-to-home": "Вернуться на главную",
        "back-to-results": "Вернуться к результатам",
        "header": "Этот сегмент должен был предоставить необходимую информацию для ответа на вопрос",
        "sub-header": "Выберите один из следующих вариантов",
        "watch-again": "Смотреть снова"
      }
    },
    "remaining-time-minutes": "Осталось {{minutes}} минут.",
    "remaining-time-seconds": "Осталось {{seconds}} секунд.",
    "watch-lesson": "Начать просмотр"
  },
  "purchase-doc": {
    "disclaimer": "Возможны несоответствия — сверьте с оригинальными документами.",
    "field": {
      "address": "Адрес",
      "eik": "ЕИК",
      "expiration-date": "Срок",
      "item-number": "Код",
      "lot-number": "Партия",
      "mol": "МОЛ",
      "name": "Наименование",
      "quantity": "Количество",
      "total-price": "Сумма",
      "unit": "Единица",
      "unit-price": "Цена за единицу"
    },
    "party": {
      "buyer": "Покупатель",
      "supplier": "Продавец"
    },
    "products": "Продукты",
    "totals": {
      "base": "Основа",
      "total": "Итого",
      "vat": "НДС"
    }
  },
  "syllabus": {
    "completed": {
      "completed-at": "Завершено <2><0></0></2> со средним баллом <5>{{scorePercent}}</5>",
      "completed-course": "Поздравляем! Вы завершили этот курс.",
      "no-completed": "Завершенных курсов нет.",
      "no-such-topic": "Такой темы не существует",
      "sign-button": "Подпишите",
      "sign-button-again": "Подпишите снова",
      "title": "Завершенные курсы"
    },
    "in-progress": {
      "course-progress": "Вы завершили {{completedLessonsCount}} тем из {{totalLessonsCount}} ({{progressPercent}}) со средним баллом {{averageScorePercent}}",
      "current-test-progress": "Текущий результат теста {{currentScorePercent}}, вам нужно как минимум {{minScorePercent}}, чтобы успешно пройти тест.",
      "days-remaining": "До срока осталось {{days}} дней",
      "from-induction-course": "Из вводного курса",
      "from-refresh-course": "Из курса повторения",
      "induction-course": "Вводный курс",
      "last-answered-at": "Последний раз ответили <1></1>",
      "no-in-progress-topic": "Нет темы в процессе изучения",
      "overdue": "Срок просрочен на {{days}} дней!",
      "refresh-course": "Курс повторения",
      "test-progress": "Тест не завершен. У вас {{totalEmployeeAnswers}} правильных ответов из {{totalCorrectAnswers}}.",
      "there-is-important-question": "Есть важный вопрос, на который дан неверный ответ.",
      "title": "Текущая тема"
    },
    "pending": {
      "locked": "Доступ к этой теме заблокирован. Есть тема, которую вы еще не завершили.",
      "no-pending-course": "Текущих курсов нет.",
      "title": "Текущий курс"
    },
    "term-signature": {
      "title": "Подпишите, что вы завершили этот курс"
    },
    "topic": {
      "completed-at": "Завершено <1></1> со счетом {{scorePercent}}.",
      "started-at": "Начато <1></1>."
    }
  },
  "test": {
    "cant-view-test": "Тест будет доступен после просмотра всей темы.",
    "cant-view-test-result": "Результат теста будет доступен после его завершения.",
    "check-the-answer-in-segment": "Посмотрите эту часть темы снова",
    "complete-test": "Завершить",
    "congrats": "Поздравляем!",
    "continue-to-next": "Перейти к следующей теме",
    "correct-answer": "Правильный ответ",
    "failed-answers-paragraph": "У вас {{questionsCount}} неверных ответов на следующие вопросы:",
    "next-question": "Далее",
    "no-answer": "Ответа нет",
    "no-test-message": "Для этой темы тест отсутствует.",
    "not-sufficient-title": "Этого недостаточно, чтобы перейти к следующей теме.",
    "prev-question": "Назад",
    "question-no": "Вопрос {{questionNo}}",
    "refresh-the-answer-in-segment": "Посмотрите эту часть темы снова",
    "result-title": "Результат теста",
    "success-rate": "Вы успешно прошли тест со счетом {{currentScorePercent}}%",
    "take-test": "Пройти тест",
    "take-test-again": "Ответьте на неверные вопросы снова",
    "take-test-again-hint": "Вы должны снова посмотреть часть темы перед ответом на вопрос.",
    "title": "Проверьте свои знания",
    "view-results": "Посмотреть результаты теста",
    "wrong-questions-title": "У вас {{questionsCount}} неверных ответов, вот правильные ответы:",
    "your-answer": "Ваш ответ",
    "your-result-is": "Ваш результат {{currentScorePercent}}%"
  },
  "ticket": {
    "action": {
      "accept": "Принять",
      "done": "Завершить",
      "print": "Печать",
      "todo": "К выполнению"
    },
    "add": {
      "content": "Описание",
      "content-placeholder": "Добавьте подробности, которые помогут решить тикет",
      "group-employees": "Сотрудники",
      "group-managers": "Руководители",
      "location": "Для местоположений",
      "location-placeholder": "К каким местоположениям относится тикет (если применимо)",
      "recipients-label": "Получатели",
      "recipients-required": "Пожалуйста, выберите хотя бы одного получателя",
      "recipients-search-placeholder": "Поиск по имени, должности или местоположению",
      "subject": "Тема",
      "subject-placeholder": "О чем этот тикет",
      "submit": "Создать",
      "title": "Новый тикет"
    },
    "change-status": "Изменить статус",
    "create-from-cc": "Создать тикет",
    "delete": {
      "confirm-message": "Вы уверены, что хотите удалить этот тикет?",
      "confirm-title": "Удаление тикета"
    },
    "detail": {
      "control-card": "<Name/> от <Date/>",
      "message-placeholder": "Напишите сообщение...",
      "refreshed": "Тикет обновлён",
      "status-changed": "<Name/> изменил(а) статус на <Status/>",
      "title": "Тикет"
    },
    "edit": {
      "submit": "Сохранить"
    },
    "filter": {
      "location": "Местоположения",
      "no-location": "Без местоположения",
      "status": "Статус",
      "text": "Поиск",
      "text-placeholder": "Поиск по тикетам...",
      "title": "Фильтр"
    },
    "new": "Новый тикет",
    "no-tickets": "Тикеты не найдены",
    "pagination-count": "{{itemCount}} тикетов",
    "status": {
      "DONE": "Завершён",
      "IN_PROGRESS": "Выполняется",
      "TODO": "К выполнению"
    },
    "tab": {
      "for-me": "Для меня",
      "from-me": "От меня"
    },
    "title": "Тикеты"
  }
}
